/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name whitespace */

import {
  Window,
  WindowType
}                           from './window';

import { DockManager }      from 'dock-spawn-ts/lib/js/DockManager';
import { PanelContainer }   from 'dock-spawn-ts/lib/js/PanelContainer';
import { PropertiesHolder } from '@/models/properties.holder';
import { Logger }           from '@/util/logger';

import * as $               from 'jquery';

/**
 *
 * @class PropertiesWindow
 *
 * @brief view panel for the currently show properties of whatever is in focus/selected.
 *
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class PropertiesWindow extends Window {

  private properties: PropertiesHolder = null;

  /** standard constructor */
  constructor(
    id: string,
    manager: DockManager
  ) {

    super(
      id,
      manager,
      WindowType.Properties,
      'Properties',
      '<i class="fas fa-info"></i>'
    );


    this.showProperties();


  }

  /** close the project view (if its open) */
  public close(implied: boolean = false) {

    Logger.debug('[PropertiesWindow] closing ', this.title);

    /* we use implied to indicate that the dock spawn manager is doing the closing; not us. */
    super.close(implied);
  }

  /** open the project view (if its closed) */
  public open() : PanelContainer {

    Logger.debug('[PropertiesWindow] opening ', this.title);

    const panel: PanelContainer = super.open();

    if(!panel) {

      Logger.error('[PropertiesWindow] can not open.');
    }

    this.showProperties();

    return panel;
  }

  /**  first time setup */
  showProperties() {

    setTimeout(() => {

      Logger.debug('[PropertiesWindow] setting  up: ', $('#projecttree'));


      this.host('#properties_window', `
  <div id="properties_window" data-panel-caption="Properties" class="properties-window  window-panel" hidden>
  <div id="propertiestable"></div>
  </div>`
      );

      this.focus();

    });
  }

  /** reset the current properties table with these properties */
  public focus(properties?: PropertiesHolder) {

    let icon: string = '<i class="fas fa-info"></i>';

    if (properties?.icon && properties.icon !== '') {

      icon = properties.icon;
    }


    this.icon  = icon;
    this.title = (properties?.title) ? properties?.title : 'Properties';

    if (!properties) {

      properties = this.properties;
    }

    if (!properties) {

      this.properties = properties;

      this.properties = null;

      $('#propertiestable').html(`
        <i style="margin: 24px; text-align: center; display: block;">Select something to view its properties.</i>
  `);

      return ;
    }

    let html = `<table class="table table-hover gui-table" cellspacing="0" cellpadding="0">`;

    html += `
<thead>
      <tr>
        <th>Property</th>
        <th>Value</th>
      </tr>
    </thead>
<tbody>`;

    /* sort the map */

    properties.properties = new Map<string,string>([...properties.properties.entries()].sort());

    /* render */

    for (const [key, value] of properties.properties) {

      html += `
 <tr>
 <td>${key}</td>
 <td>${value}</td>
 </tr>
 `;

    }

    html += `</tbody></table>`;

    /* render */

    // noinspection JSJQueryEfficiency
    $('#propertiestable').html(html);
  }

}
